function Success() {
    return (
        <div>
            <h1> Thank you for your purchase</h1>
        </div>
    )

}

export default Success;